import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import AudioPlayer from "@/components/AudioPlayer";

const LANGS = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "la", label: "Latina" },
];

const PrayerDetail = () => {
    const { slug } = useParams();
    const [prayer, setPrayer] = useState(null);
    const [lang, setLang] = useState("en");

    useEffect(() => { api.get(`/prayers/${slug}`).then(r => setPrayer(r.data)); }, [slug]);

    if (!prayer) return <div className="max-w-3xl mx-auto py-24 text-center text-muted-foreground">Loading…</div>;

    return (
        <div className="max-w-3xl mx-auto px-6 py-16" data-testid="prayer-detail-page">
            <Link to="/prayers" className="small-caps text-xs accent-liturgy hover:underline">← Back to Prayers</Link>
            <div className="text-center mt-8">
                <div className="small-caps text-xs text-muted-foreground">{prayer.category}</div>
                <h1 className="font-serif text-4xl md:text-5xl mt-3" data-testid="prayer-title">{prayer.title[lang] || prayer.title.en}</h1>
                <p className="mt-6 text-muted-foreground italic max-w-xl mx-auto">{prayer.description}</p>
            </div>

            <div className="mt-10 flex items-center justify-center gap-1" data-testid="lang-switcher">
                {LANGS.map(l => (
                    <button key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-${l.code}`}
                        className={`px-4 py-2 text-xs small-caps border ${lang===l.code ? 'border-liturgy accent-liturgy' : 'border-border text-muted-foreground hover:accent-liturgy'}`}>
                        {l.label}
                    </button>
                ))}
            </div>

            <div className="mt-8">
                <AudioPlayer slug={prayer.slug} language={lang} voice={prayer.voice} />
            </div>

            <div className="mt-10 missal-card p-8 md:p-12">
                <p className="dropcap font-body text-lg leading-loose" data-testid="prayer-text">
                    {prayer.text[lang] || prayer.text.en}
                </p>
            </div>

            <div className="mt-10 missal-card p-8 text-center opacity-60">
                <div className="small-caps text-[11px] text-muted-foreground mb-2">Coming soon</div>
                <div className="text-sm text-muted-foreground">A YouTube video slot for this prayer, ready to be filled when the channel is live.</div>
            </div>
        </div>
    );
};

export default PrayerDetail;
